import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Calendar as ReactCalendar } from 'react-calendar/dist/entry.nostyle';
import moment from 'moment';
import _ from 'lodash';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import every from 'lodash/every';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components';
import { ifProp, ifNotProp, prop } from 'styled-tools';
import { lighten } from 'polished';
import ReactCalendarWrapper from './ReactCalendarWrapper';
import DayTile from './DayTile';
import ImageSliderContainer from 'containers/ImageSliderContainer';
import SpinnerContainer from './styled/SpinnerContainer';
import Button from 'components/Button';
import { isMobileUserAgent } from 'utils/mobile';
import { addPropertyImagePrefix } from 'utils/images';
import {
  ROOM_TYPE_CODES_FOR_SIZE,
  ALL,
  MAX_DISCOUNTED_OR_COMP_NIGHTS,
  RACK_RATE
} from 'utils/constants';
import { hotelCalendarDayShape, hotelOfferShape } from 'utils/shapes';
import {
  PROPERTY_ATMORE,
  PROPERTY_MONTGOMERY,
  PROPERTY_WETUMPKA,
  PROPERTY_BETHLEHEM
} from 'utils/constants';
import { roomRateIsComp } from 'utils/roomRates';

const atmoreImageThumb1 = 'atmore/bathroom-thumb.jpg';
const atmoreImageThumb3 = 'atmore/casino-floor-thumb.jpg';
const atmoreImageThumb4 = 'atmore/casino-floor-2-thumb.jpg';
const atmoreImageThumb5 = 'atmore/dining-thumb.jpg';
const atmoreImageThumb6 = 'atmore/dining-2-thumb.jpg';
const atmoreImageThumb7 = 'atmore/dining-3-thumb.jpg';
const atmoreImageThumb8 = 'atmore/exterior-thumb.jpg';
const atmoreImageThumb9 = 'atmore/food-service-thumb.jpg';
const atmoreImageThumb10 = 'atmore/room-thumb.jpg';
const atmoreImageThumb11 = 'atmore/room-2-thumb.jpg';
const atmoreImageThumb12 = 'atmore/room-service-thumb.jpg';
const atmoreImageThumb13 = 'atmore/turkey-sliders-thumb.jpg';
const atmoreImageThumb14 = 'atmore/sink-thumb.jpg';
const atmoreImageThumb15 = 'atmore/wine-thumb.jpg';

const bethlehemImageThumb1 =
  'bethlehem/20170603_Emeril_Fish_House-0091-min_tn.jpg';
const bethlehemImageThumb2 = 'bethlehem/49519_promo_1_tn.jpg';
const bethlehemImageThumb3 = 'bethlehem/49519_promo_2_tn.jpg';
const bethlehemImageThumb4 = 'bethlehem/49519_promo_3_tn.jpg';
const bethlehemImageThumb5 = 'bethlehem/49519_promo_4_tn.jpg';
const bethlehemImageThumb6 = 'bethlehem/Burgers and More By Emeril-min_tn.jpg';
const bethlehemImageThumb7 = 'bethlehem/Casino Floor-min_tn.jpg';
const bethlehemImageThumb8 = 'bethlehem/Cyber Quest-min_tn.jpg';
const bethlehemImageThumb9 = 'bethlehem/Electronic Table Games-min_tn.jpg';
const bethlehemImageThumb10 = "bethlehem/Emeril's Chop House2-min_tn.jpg";
const bethlehemImageThumb11 = "bethlehem/Emeril's Chop House-min_tn.jpg";
const bethlehemImageThumb12 = "bethlehem/Emeril's Fish House-min_tn.jpg";
const bethlehemImageThumb13 = 'bethlehem/Event Center Show-min_tn.jpg';
const bethlehemImageThumb14 = 'bethlehem/Exterior 2-min_tn.jpg';
const bethlehemImageThumb15 = 'bethlehem/Exterior-min_tn.jpg';
const bethlehemImageThumb16 = 'bethlehem/Fitness Room-min_tn.jpg';
const bethlehemImageThumb17 = 'bethlehem/High Limit Table Games-min_tn.jpg';
const bethlehemImageThumb18 = 'bethlehem/Hotel Pool 2-min_tn.jpg';
const bethlehemImageThumb19 = 'bethlehem/Hotel Pool-min_tn.jpg';
const bethlehemImageThumb20 = "bethlehem/Kid's Quest-min_tn.jpg";
const bethlehemImageThumb21 = 'bethlehem/Molten Lounge-min_tn.jpg';
const bethlehemImageThumb22 = 'bethlehem/Poker Room-min_tn.jpg';
const bethlehemImageThumb23 = 'bethlehem/promo_shot-min_tn.jpg';
const bethlehemImageThumb24 =
  'bethlehem/Steelworks Buffet and Grill-min_tn.jpg';
const bethlehemImageThumb25 = 'bethlehem/The Outlets Entrance-min_tn.jpg';
const bethlehemImageThumb26 = 'bethlehem/The Salon-min_tn.jpg';

const montgomeryImageThumb1 = 'montgomery/exterior-thumb.jpg';
const montgomeryImageThumb2 = 'montgomery/elevators-thumb.jpg';
const montgomeryImageThumb3 = 'montgomery/suite-bathroom-thumb.jpg';
const montgomeryImageThumb4 = 'montgomery/double-queen-thumb.jpg';
const montgomeryImageThumb5 = 'montgomery/suite-bedroom-thumb.jpg';
const montgomeryImageThumb6 = 'montgomery/panoramic-thumb.jpg';
const montgomeryImageThumb7 = 'montgomery/king-thumb.jpg';
const montgomeryImageThumb8 = 'montgomery/suite-living-room-thumb.jpg';
const montgomeryImageThumb9 = 'montgomery/exterior-2-thumb.jpg';
const montgomeryImageThumb10 = 'montgomery/exterior-3-thumb.jpg';
const montgomeryImageThumb11 = 'montgomery/exterior-4-thumb.jpg';
const montgomeryImageThumb12 = 'montgomery/exterior-5-thumb.jpg';
const montgomeryImageThumb13 = 'montgomery/exterior-6-thumb.jpg';
const montgomeryImageThumb14 = 'montgomery/interior-thumb.jpg';
const montgomeryImageThumb15 = 'montgomery/interior-2-thumb.jpg';
const montgomeryImageThumb16 = 'montgomery/interior-3-thumb.jpg';
const montgomeryImageThumb17 = 'montgomery/interior-4-thumb.jpg';
const montgomeryImageThumb18 = 'montgomery/interior-5-thumb.jpg';
const montgomeryImageThumb19 = 'montgomery/interior-6-thumb.jpg';

const wetumpkaImageThumb1 = 'wetumpka/room-thumb.jpg';
const wetumpkaImageThumb2 = 'wetumpka/food-thumb.jpg';
const wetumpkaImageThumb3 = 'wetumpka/games-thumb.jpg';
const wetumpkaImageThumb4 = 'wetumpka/exterior-thumb.png';

const atmoreImage1 = 'atmore/bathroom.jpg';
const atmoreImage3 = 'atmore/casino-floor.jpg';
const atmoreImage4 = 'atmore/casino-floor-2.jpg';
const atmoreImage5 = 'atmore/dining.jpg';
const atmoreImage6 = 'atmore/dining-2.jpg';
const atmoreImage7 = 'atmore/dining-3.jpg';
const atmoreImage8 = 'atmore/exterior.jpg';
const atmoreImage9 = 'atmore/food-service.jpg';
const atmoreImage10 = 'atmore/room.jpg';
const atmoreImage11 = 'atmore/room-2.jpg';
const atmoreImage12 = 'atmore/room-service.jpg';
const atmoreImage13 = 'atmore/turkey-sliders.jpg';
const atmoreImage14 = 'atmore/sink.jpg';
const atmoreImage15 = 'atmore/wine.jpg';

const bethlehemImage1 = 'bethlehem/20170603_Emeril_Fish_House-0091-min.jpg';
const bethlehemImage2 = 'bethlehem/49519_promo_1.jpg';
const bethlehemImage3 = 'bethlehem/49519_promo_2.jpg';
const bethlehemImage4 = 'bethlehem/49519_promo_3.jpg';
const bethlehemImage5 = 'bethlehem/49519_promo_4.jpg';
const bethlehemImage6 = 'bethlehem/Burgers and More By Emeril-min.jpg';
const bethlehemImage7 = 'bethlehem/Casino Floor-min.jpg';
const bethlehemImage8 = 'bethlehem/Cyber Quest-min.jpg';
const bethlehemImage9 = 'bethlehem/Electronic Table Games-min.jpg';
const bethlehemImage10 = "bethlehem/Emeril's Chop House2-min.jpg";
const bethlehemImage11 = "bethlehem/Emeril's Chop House-min.jpg";
const bethlehemImage12 = "bethlehem/Emeril's Fish House-min.jpg";
const bethlehemImage13 = 'bethlehem/Event Center Show-min.jpg';
const bethlehemImage14 = 'bethlehem/Exterior 2-min.jpg';
const bethlehemImage15 = 'bethlehem/Exterior-min.jpg';
const bethlehemImage16 = 'bethlehem/Fitness Room-min.jpg';
const bethlehemImage17 = 'bethlehem/High Limit Table Games-min.jpg';
const bethlehemImage18 = 'bethlehem/Hotel Pool 2-min.jpg';
const bethlehemImage19 = 'bethlehem/Hotel Pool-min.jpg';
const bethlehemImage20 = "bethlehem/Kid's Quest-min.jpg";
const bethlehemImage21 = 'bethlehem/Molten Lounge-min.jpg';
const bethlehemImage22 = 'bethlehem/Poker Room-min.jpg';
const bethlehemImage23 = 'bethlehem/promo_shot-min.jpg';
const bethlehemImage24 = 'bethlehem/Steelworks Buffet and Grill-min.jpg';
const bethlehemImage26 = 'bethlehem/The Salon-min.jpg';

const montgomeryImage1 = 'montgomery/exterior.jpg';
const montgomeryImage2 = 'montgomery/elevators.jpg';
const montgomeryImage3 = 'montgomery/suite-bathroom.jpg';
const montgomeryImage4 = 'montgomery/double-queen.jpg';
const montgomeryImage5 = 'montgomery/suite-bedroom.jpg';
const montgomeryImage6 = 'montgomery/panoramic.jpg';
const montgomeryImage7 = 'montgomery/king.jpg';
const montgomeryImage8 = 'montgomery/suite-living-room.jpg';
const montgomeryImage9 = 'montgomery/exterior-2.jpg';
const montgomeryImage10 = 'montgomery/exterior-3.jpg';
const montgomeryImage11 = 'montgomery/exterior-4.jpg';
const montgomeryImage12 = 'montgomery/exterior-5.jpg';
const montgomeryImage13 = 'montgomery/exterior-6.jpg';
const montgomeryImage14 = 'montgomery/interior.jpg';
const montgomeryImage15 = 'montgomery/interior-2.jpg';
const montgomeryImage16 = 'montgomery/interior-3.jpg';
const montgomeryImage17 = 'montgomery/interior-4.jpg';
const montgomeryImage18 = 'montgomery/interior-5.jpg';
const montgomeryImage19 = 'montgomery/interior-6.jpg';

const wetumpkaImage1 = 'wetumpka/room.jpg';
const wetumpkaImage2 = 'wetumpka/food.jpg';
const wetumpkaImage3 = 'wetumpka/games.jpg';
const wetumpkaImage4 = 'wetumpka/exterior.png';

const SLIDER_IMAGES = {
  [PROPERTY_ATMORE]: [
    atmoreImageThumb1,
    atmoreImageThumb3,
    atmoreImageThumb4,
    atmoreImageThumb5,
    atmoreImageThumb6,
    atmoreImageThumb7,
    atmoreImageThumb8,
    atmoreImageThumb9,
    atmoreImageThumb10,
    atmoreImageThumb11,
    atmoreImageThumb12,
    atmoreImageThumb13,
    atmoreImageThumb14,
    atmoreImageThumb15
  ].map(addPropertyImagePrefix),
  [PROPERTY_BETHLEHEM]: [
    bethlehemImageThumb1,
    bethlehemImageThumb2,
    bethlehemImageThumb3,
    bethlehemImageThumb4,
    bethlehemImageThumb5,
    bethlehemImageThumb6,
    bethlehemImageThumb7,
    bethlehemImageThumb8,
    bethlehemImageThumb9,
    bethlehemImageThumb10,
    bethlehemImageThumb11,
    bethlehemImageThumb12,
    bethlehemImageThumb13,
    bethlehemImageThumb14,
    bethlehemImageThumb15,
    bethlehemImageThumb16,
    bethlehemImageThumb17,
    bethlehemImageThumb18,
    bethlehemImageThumb19,
    bethlehemImageThumb20,
    bethlehemImageThumb21,
    bethlehemImageThumb22,
    bethlehemImageThumb23,
    bethlehemImageThumb24,
    bethlehemImageThumb25,
    bethlehemImageThumb26
  ].map(addPropertyImagePrefix),
  [PROPERTY_MONTGOMERY]: [
    montgomeryImageThumb1,
    montgomeryImageThumb2,
    montgomeryImageThumb3,
    montgomeryImageThumb4,
    montgomeryImageThumb5,
    montgomeryImageThumb6,
    montgomeryImageThumb7,
    montgomeryImageThumb8,
    montgomeryImageThumb9,
    montgomeryImageThumb10,
    montgomeryImageThumb11,
    montgomeryImageThumb12,
    montgomeryImageThumb13,
    montgomeryImageThumb14,
    montgomeryImageThumb15,
    montgomeryImageThumb16,
    montgomeryImageThumb17,
    montgomeryImageThumb18,
    montgomeryImageThumb19
  ].map(addPropertyImagePrefix),
  [PROPERTY_WETUMPKA]: [
    wetumpkaImageThumb1,
    wetumpkaImageThumb2,
    wetumpkaImageThumb3,
    wetumpkaImageThumb4
  ].map(addPropertyImagePrefix)
};

const LIGHTBOX_IMAGES = {
  [PROPERTY_ATMORE]: [
    atmoreImage1,
    atmoreImage3,
    atmoreImage4,
    atmoreImage5,
    atmoreImage6,
    atmoreImage7,
    atmoreImage8,
    atmoreImage9,
    atmoreImage10,
    atmoreImage11,
    atmoreImage12,
    atmoreImage13,
    atmoreImage14,
    atmoreImage15
  ].map(addPropertyImagePrefix),
  [PROPERTY_BETHLEHEM]: [
    bethlehemImage1,
    bethlehemImage2,
    bethlehemImage3,
    bethlehemImage4,
    bethlehemImage5,
    bethlehemImage6,
    bethlehemImage7,
    bethlehemImage8,
    bethlehemImage9,
    bethlehemImage10,
    bethlehemImage11,
    bethlehemImage12,
    bethlehemImage13,
    bethlehemImage14,
    bethlehemImage15,
    bethlehemImage16,
    bethlehemImage17,
    bethlehemImage18,
    bethlehemImage19,
    bethlehemImage20,
    bethlehemImage21,
    bethlehemImage22,
    bethlehemImage23,
    bethlehemImage24,
    bethlehemImage26
  ].map(addPropertyImagePrefix),
  [PROPERTY_MONTGOMERY]: [
    montgomeryImage1,
    montgomeryImage2,
    montgomeryImage3,
    montgomeryImage4,
    montgomeryImage5,
    montgomeryImage6,
    montgomeryImage7,
    montgomeryImage8,
    montgomeryImage9,
    montgomeryImage10,
    montgomeryImage11,
    montgomeryImage12,
    montgomeryImage13,
    montgomeryImage14,
    montgomeryImage15,
    montgomeryImage16,
    montgomeryImage17,
    montgomeryImage18,
    montgomeryImage19
  ].map(addPropertyImagePrefix),
  [PROPERTY_WETUMPKA]: [
    wetumpkaImage1,
    wetumpkaImage2,
    wetumpkaImage3,
    wetumpkaImage4
  ].map(addPropertyImagePrefix)
};

const StyledModalGateway = styled(ModalGateway)`
  ${ifProp(
    'isHostBooking',
    css`
      @media screen and (max-width: ${prop('theme.breakpoints.small')}) {
        position: absolute;
        top: 0;
      }
    `
  )}
`;

const StyledModal = styled(Modal)`
  ${ifProp(
    'mobile',
    css`
      position: fixed;
      height: ${prop('page.height')}px;
      top: ${prop('page.scrollY')}px;
      min-height: unset;
    `
  )}
`;

const ClearButton = styled(Button)`
  z-index: 2;
  margin: 0.5em 0;

  @media screen and (min-width: ${prop('theme.breakpoints.extraSmall')}) {
    background: ${props =>
      lighten(0.2, props.theme.buttons.primary.backgroundColor)};
    position: relative;
    top: 2.7em;
    left: 4.1em;
    width: fit-content;
    max-width: 5em;
    height: 2.4em;
    margin-top: -2.4em;
    border-radius: 0.2em;
    border: 0;
    padding: 0 0.5em;
    font-size: 0.8rem;
    margin-bottom: 0;

    &:hover {
      background-color: ${props =>
        lighten(
          0.12,
          props.secondary
            ? props.theme.buttons.secondary.backgroundColor
            : props.theme.buttons.primary.backgroundColor
        )};
    }
  }

  @media screen and (min-width: ${prop('theme.breakpoints.small')}) {
    top: 3.55em;
    left: 4.2em;
    height: 3.2em;
    margin-top: -3.2em;
  }
`;

class Calendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      calendarDayFontSize: '1em',
      currentImage: 0,
      lightboxIsOpen: false,
      isMobile: false
    };
  }

  componentDidMount() {
    const isMobile = isMobileUserAgent();

    if (isMobile) {
      this.handleMobileEvent(isMobile);
      window.addEventListener('mobile', this.handleMobileEvent);
    }

    if (!document.addEventListener && !window.attachEvent) {
      return;
    }

    // Make the initial call manually. When navigating back to this page in the app,
    // DOM has already loaded and the onload event has already fired, so unless we
    // manually set font size, it will default to 1em.
    this.setCalendarDayFontSize();

    if (window.attachEvent) {
      window.attachEvent('onresize', this.setCalendarDayFontSize, false);
      window.attachEvent('onload', this.setCalendarDayFontSize, false);
    } else if (window.addEventListener) {
      window.addEventListener('resize', this.setCalendarDayFontSize, false);
      document.addEventListener(
        'DOMContentLoaded',
        this.setCalendarDayFontSize,
        false
      );
    }

    if (this.props.isHostBooking) {
      this.setState({
        calendarDayFontSize: '0.688em'
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    let vw = window.innerWidth;
    let lightboxTop = document.querySelector('#root');

    if (
      vw < 576 &&
      nextState.lightboxIsOpen === true &&
      this.state.lightboxIsOpen === false
    ) {
      lightboxTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  componentWillUnmount() {
    if (window.detachEvent) {
      window.detachEvent('onresize', this.setCalendarDayFontSize, false);
      window.detachEvent('onload', this.setCalendarDayFontSize, false);
    } else if (window.removeEventListener) {
      window.removeEventListener('resize', this.setCalendarDayFontSize, false);
      document.removeEventListener(
        'DOMContentLoaded',
        this.setCalendarDayFontSize,
        false
      );
      window.removeEventListener('mobile', this.handleMobileEvent);
    }
  }

  handleMobileEvent = mobile => {
    const { isMobile } = this.state;

    if (isMobile !== mobile) {
      this.setState({
        isMobile: mobile
      });
    }
  };

  setCalendarDayFontSize = () => {
    const { isHostBooking } = this.props;
    const hostBookingFontSize = isHostBooking ? '0.688em' : '1em';
    const tiles = document.getElementsByClassName('react-calendar__tile');

    this.setState({
      calendarDayFontSize:
        tiles && tiles[0]
          ? 0.18 * tiles[0].clientWidth + 'px'
          : hostBookingFontSize
    });
  };

  isDayDisabled = ({ date }) => {
    const { queryInput, startDate, endDate } = this.props;

    const momentDate = moment(date);
    const startOfMonth = moment(queryInput.startDate);

    const day = this.getCalendarDay(date);

    return (
      !this.isDaySelected(date, startDate, endDate) &&
      (!day ||
        momentDate.isBefore(startOfMonth.startOf('day')) ||
        momentDate.isBefore(moment().startOf('day')) ||
        momentDate.isAfter(startOfMonth.endOf('month')))
    );
  };

  isDaySelected = (date, startDate, endDate) => {
    if (!startDate || !endDate) {
      return false;
    }

    return moment(date).isBetween(
      moment(startDate),
      moment(endDate),
      'day',
      '[]'
    );
  };

  isRoomTypeSelected(targetRoomType, checkBestRoomType = true) {
    const { roomType, bestRoomType } = this.props;

    if (checkBestRoomType && bestRoomType) {
      return targetRoomType === bestRoomType;
    }

    return (
      roomType.value === ALL ||
      ROOM_TYPE_CODES_FOR_SIZE[roomType.value].includes(targetRoomType)
    );
  }

  dayIsEligibleForComp = (day, roomType, checkBestRoomType = true) => {
    let rateEligibleForComp = false;

    if (day && roomType) {
      rateEligibleForComp = find(day.roomRates, rate => {
        return (
          this.isRoomTypeSelected(rate.roomTypeCode, checkBestRoomType) &&
          rate.eligibleForComp
        );
      });
    }

    return !!rateEligibleForComp;
  };

  canBeDiscounted = day => {
    return (
      _.filter(day.roomRates, rate => rate.ratePlanCode !== RACK_RATE).length >
      0
    );
  };

  hasNoOffers = day => {
    return (
      _.chain(day.roomRates)
        .map(rate => rate.offers)
        .flatten()
        .value().length === 0
    );
  };

  getCalendarDay(date) {
    const { calendarDays } = this.props;

    const formattedDate = moment(date).format('YYYY-MM-DD');
    return calendarDays && find(calendarDays, { date: formattedDate });
  }

  renderTileContent = ({ date }) => {
    const {
      loading,
      calendarDays,
      startDate,
      endDate,
      selectedOffers,
      roomType,
      isHostBooking,
      hotelOverrideCodes,
      property
    } = this.props;

    if (this.isDayDisabled({ date }) || loading) {
      return null;
    }

    const day = this.getCalendarDay(date);
    const isSelected = this.isDaySelected(date, startDate, endDate);
    const minimumRate = this.minimumPaidDayRate(
      day,
      roomType,
      isSelected,
      property
    );

    // selectedOffers maps dates to offers. This array represents selected days in the stay
    // that are comped.
    const compedDays = Object.keys(selectedOffers).map(date =>
      this.getCalendarDay(date)
    );

    // Get all selected dates that have rates that are not 10_FIT
    // and either have no offers available, or can't be comped.
    // These are the dates in the stay that can be discounted.
    // This also includes days which are eligible for comp, but the max
    // number of comps has already been used.
    const discountableDays =
      calendarDays &&
      _.filter(calendarDays, day => {
        const isDayComped = !!_.find(compedDays, day);
        const maxCompsReached =
          compedDays.length === MAX_DISCOUNTED_OR_COMP_NIGHTS;

        return (
          this.isDaySelected(day.date, startDate, endDate) &&
          this.canBeDiscounted(day) &&
          (this.hasNoOffers(day) ||
            !this.dayIsEligibleForComp(day, roomType, isSelected) ||
            (!isDayComped && maxCompsReached))
        );
      });

    const selectedDates = [...compedDays, ...discountableDays];

    // If the max number of comps or discounts has been used, we show the rack rate
    // if the day isn't selected, or if it is, but it falls after the comped/discounted dates.
    const useRackRate =
      selectedDates.length >= MAX_DISCOUNTED_OR_COMP_NIGHTS &&
      (!isSelected ||
        _.indexOf(selectedDates, day) >= MAX_DISCOUNTED_OR_COMP_NIGHTS);
    const rackRate = this.getRackRate(day, roomType, isSelected);

    return (
      <DayTile
        hotelCalendarDay={day || null}
        startDate={startDate}
        endDate={endDate}
        selectedOffers={selectedOffers}
        roomType={roomType}
        minimumRate={minimumRate}
        isSelected={isSelected}
        rackRate={rackRate}
        useRackRate={useRackRate}
        isCompable={this.dayIsEligibleForComp(day, roomType, isSelected)}
        isHostBooking={isHostBooking}
        hotelOverrideCodes={hotelOverrideCodes}
      />
    );
  };

  getRackRate = (calendarDay, roomType, filterByBestRoomType = true) => {
    let rackRate = null;
    if (calendarDay && roomType) {
      // If a room type has been selected from the dropdown,
      // this grabs only the rack rate for that room type.
      // Otherwise, it grabs all rack rates.
      const rackRates = _.filter(calendarDay.roomRates, rate => {
        const roomTypeSelected = this.isRoomTypeSelected(
          rate.roomTypeCode,
          filterByBestRoomType
        );

        return roomTypeSelected && rate.ratePlanCode === RACK_RATE;
      });

      rackRate = _.minBy(
        rackRates,
        rate => rate.rates.length > 0 && rate.rates[0].base.amount
      );
    }

    return rackRate && rackRate.rates.length > 0
      ? rackRate.rates[0].base.amount
      : null;
  };

  minimumPaidDayRate = (
    calendarDay,
    roomType,
    filterByBestRoomType = true,
    property
  ) => {
    let minRate = null;
    if (calendarDay && roomType) {
      const rates = _.filter(calendarDay.roomRates, rate => {
        const roomTypeSelected = this.isRoomTypeSelected(
          rate.roomTypeCode,
          filterByBestRoomType
        );

        const isNotCompRate =
          rate.rates.length > 0 &&
          !roomRateIsComp(rate.rates[0].base.amount, property);

        return roomTypeSelected && isNotCompRate;
      });

      minRate = _.minBy(
        rates,
        roomRate => roomRate.rates.length > 0 && roomRate.rates[0].base.amount
      );
    }

    return minRate && minRate.rates.length > 0
      ? minRate.rates[0].base.amount
      : null;
  };

  formatMonth = value => {
    return moment(value).format('MMMM YYYY');
  };

  onActiveDateChange = ({ activeStartDate, view }) => {
    const { setQueryInput } = this.props;

    setQueryInput(activeStartDate);
  };

  toggleLightbox = imageIndex => {
    this.setState({
      lightboxIsOpen: !this.state.lightboxIsOpen,
      currentImage: imageIndex
    });
  };

  handlePrevClick = () => {
    const { currentImage } = this.state;

    this.setState({ currentImage: currentImage - 1 });
  };

  handleNextClick = () => {
    const { currentImage } = this.state;

    this.setState({ currentImage: currentImage + 1 });
  };

  onDatesChange = e => {
    const { onDatesChange } = this.props;

    this.setActiveBlockCode(e[0], e[1]);

    onDatesChange(e);
  };

  setActiveBlockCode = (start, end) => {
    const { calendarDays, setActiveBlock, blockCode } = this.props;

    const startDate = moment(start).format('YYYY-MM-DD');
    const endDate = moment(end).format('YYYY-MM-DD');
    const startDateIndex = findIndex(calendarDays, { date: startDate });
    const endDateIndex = findIndex(calendarDays, { date: endDate });
    const selectedDateRange = calendarDays.slice(
      startDateIndex,
      endDateIndex + 1
    );

    if (every(selectedDateRange, day => day.isBlockCodeDay)) {
      setActiveBlock({ code: blockCode });
    } else {
      setActiveBlock(null);
    }
  };

  render() {
    const {
      startDate,
      endDate,
      property,
      loading,
      onClickDay,
      activeStartDate,
      isHostBooking,
      clearDates
    } = this.props;
    const {
      calendarDayFontSize,
      lightboxIsOpen,
      currentImage,
      isMobile
    } = this.state;

    const days = document.getElementsByClassName('react-calendar__tile');
    const sixWeekMonth = days && days.length > 35;

    const images = property ? SLIDER_IMAGES[property] : [];
    const lightboxImages = property ? LIGHTBOX_IMAGES[property] : [];

    const sliderSettings = {
      autoplay: true,
      autoplaySpeed: 1000,
      speed: 5000,
      cssEase: 'linear',
      pauseOnHover: false,
      draggable: false,
      swipeToSlide: true,
      variableWidth: true,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    const calendarValue =
      startDate && endDate ? [startDate, endDate] : startDate || endDate;

    return (
      <React.Fragment>
        <ClearButton onClick={clearDates} isMobile={isMobile}>
          Clear
        </ClearButton>
        <ReactCalendarWrapper
          calendarDayFontSize={calendarDayFontSize}
          sixWeekMonth={sixWeekMonth}
          isHostBooking={isHostBooking}
        >
          {loading && (
            <SpinnerContainer>
              <FontAwesomeIcon
                icon="spinner"
                size="5x"
                spin
                role="presentation"
              />
            </SpinnerContainer>
          )}
          <ReactCalendar
            className={loading ? 'calendar-loading' : 'calendar-loaded'}
            minDetail="month"
            selectRange={true}
            value={calendarValue}
            onChange={this.onDatesChange}
            onClickDay={onClickDay}
            returnValue="range"
            tileDisabled={this.isDayDisabled}
            tileContent={this.renderTileContent}
            minDate={new Date()}
            formatMonthYear={this.formatMonth}
            activeStartDate={activeStartDate}
            onActiveDateChange={this.onActiveDateChange}
            calendarType="US"
          />
        </ReactCalendarWrapper>
        {!isHostBooking && (
          <div
            style={{
              height: '6em',
              margin: '1em 1.75em 0 1.75em'
            }}
          >
            <ImageSliderContainer
              images={images}
              settings={sliderSettings}
              showLightbox={this.toggleLightbox}
            />
            <StyledModalGateway
              isMobile={isMobile}
              isHostBooking={isHostBooking}
            >
              {lightboxIsOpen ? (
                <StyledModal
                  onClose={this.toggleLightbox}
                  styles={{
                    blanket: base => ({
                      ...base,
                      zIndex: 100
                    }),
                    positioner: base => ({
                      ...base,
                      zIndex: 100
                    })
                  }}
                  mobile={isMobile}
                  className="Styled Modal Test"
                >
                  <Carousel
                    views={lightboxImages.map(img => ({ src: img }))}
                    currentIndex={currentImage}
                  />
                </StyledModal>
              ) : null}
            </StyledModalGateway>
          </div>
        )}
      </React.Fragment>
    );
  }
}

Calendar.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  onDatesChange: PropTypes.func,
  offers: PropTypes.arrayOf(hotelOfferShape),
  selectedOffers: PropTypes.object,
  calendarDays: PropTypes.arrayOf(hotelCalendarDayShape),
  loading: PropTypes.bool,
  roomType: PropTypes.object,
  property: PropTypes.string,
  bestRoomType: PropTypes.string,
  isHostBooking: PropTypes.bool,
  activeStartDate: PropTypes.any,
  setActiveBlock: PropTypes.func,
  blockCode: PropTypes.string,
  hotelOverrideCodes: PropTypes.shape({
    id: PropTypes.number,
    hotelCode: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    lastModified: PropTypes.string
  })
};

export default Calendar;
